module.exports = __webpack_public_path__ + "img/case5-bg.c91ab4c1.jpg";